import React from 'react';
import { SectionLabel } from './ui/SectionLabel';
import { InteriorCarousel } from './InteriorCarousel';
const labels = ['Class Intention', 'Duration', 'Level', 'Props', 'Opening', 'Warm-Up', 'Main Sequence', 'Teaching Cues', 'Transitions', 'Modifications', 'Cooldown', 'Closing'];
const stats = [{
  value: '120',
  label: 'Complete classes'
}, {
  value: '6',
  label: 'Professional volumes'
}, {
  value: '20',
  label: 'Classes per volume'
}, {
  value: '40+',
  label: 'Weeks of material'
}];
export function InsideSystemSection() {
  return <section className="w-full bg-sand py-10 sm:py-14 lg:py-20" aria-labelledby="inside-heading" data-id="element-81" data-mp="isnmr5ob3o4f">
      <div className="mx-auto w-full max-w-content px-5 sm:px-8" data-id="element-82" data-mp="dtksmg9v72b8">
        <div className="mx-auto max-w-2xl text-center" data-id="element-83" data-mp="dt1cn53rynzu">
          <div className="flex justify-center" data-id="element-84" data-mp="33jeelspl66hh">
            <SectionLabel data-id="element-85" data-mp="33k69t2f9u278">Inside the system</SectionLabel>
          </div>
          <h2 id="inside-heading" className="mt-3 font-serif text-[1.6rem] font-semibold uppercase leading-[1.08] text-ink sm:text-4xl" data-id="element-86" data-mp="2yj0eqxy522uj">
            Take a look <span className="text-forest" data-id="element-87" data-mp="20hpqsgb9hbpg">inside</span>
          </h2>
          <p className="mx-auto mt-3 max-w-lg text-[0.9rem] leading-snug text-muted sm:text-lg" data-id="element-88" data-mp="1lk72tg6er2j2">
            See the actual class structures, teaching guidance and professional resources included
            inside Yoga Teacher System™.
          </p>
        </div>

        <InteriorCarousel data-id="element-89" data-mp="1cqka5yxhyfe3" />

        <p className="mt-5 text-center font-serif text-[1rem] font-semibold uppercase leading-tight text-ink sm:text-xl" data-id="element-90" data-mp="1hili58nmtjyb">
          Real pages. Complete classes. Ready to teach.
        </p>

        <ul className="mt-5 grid grid-cols-2 gap-2 sm:grid-cols-3 lg:grid-cols-4" data-id="element-91" data-mp="12ruso79iiwyd">
          {labels.map(label => <li key={label} className="rounded-xl border border-sandDark bg-ivory px-3 py-2.5 text-center text-[0.65rem] font-semibold uppercase leading-tight tracking-label text-ink sm:text-[0.7rem]" data-id="element-92" data-mp="tt9espezk63x">
              {label}
            </li>)}
        </ul>

        <ul className="mt-6 grid grid-cols-2 gap-2.5 sm:grid-cols-4" data-id="element-93" data-mp="2vq1d543gif2o">
          {stats.map(({
          value,
          label
        }) => <li key={label} className="rounded-2xl border border-gold/30 bg-ivory px-3 py-4 text-center" data-id="element-94" data-mp="2qsi20d222iey">
              <p className="font-serif text-3xl font-semibold leading-none text-forest sm:text-4xl" data-id="element-95" data-mp="2lqivwvexl7eb">
                {value}
              </p>
              <p className="mt-1.5 text-[0.58rem] font-semibold uppercase tracking-label text-muted" data-id="element-96" data-mp="3egrj51obqhzr">
                {label}
              </p>
            </li>)}
        </ul>

        <p className="mx-auto mt-5 max-w-xl text-center font-serif text-[1rem] font-semibold uppercase leading-tight text-forest sm:text-xl" data-id="element-97" data-mp="35gw0ycwcpmq8">
          Months of teaching material without starting every class from zero.
        </p>
      </div>
    </section>;
}